import React, { useEffect, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import styled from "styled-components";
import ExcelBtn from "../../../component/atoms/button/excelBtn";
import DatePicker from "../_components/datePicker";
import Modal from "../../../component/templates/Modal";
import TableText from "./../../../component/atoms/text/table/tableText";
import { formatNumberWithCommas } from "./../../../util/formatNumber";
import PretendardText from "./../../../component/atoms/text/mainText";

const StatisticsInflowSearch = () => {
  const [popupIsOpen, setPopupIsOpen] = useState(false);

  const [selectedStartDate, setSelectedStartDate] = useState("");

  const [selectedEndDate, setSelectedEndDate] = useState("");

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");

  useEffect(() => {
    if (selectedStartDate === "" && selectedEndDate !== "") {
      setModalIsOpen(true);
      setModalTitle("날짜 선택 오류");
      setModalText("시작 날짜를 선택해주세요.");
      setSelectedStartDate("");
      setSelectedEndDate("");
    }

    if (selectedEndDate !== "" && selectedStartDate > selectedEndDate) {
      setModalIsOpen(true);
      setModalTitle("날짜 선택 오류");
      setModalText("끝 날짜가 시작 날짜보다 빠를 수 없습니다.");
      setSelectedEndDate("");
    }
  }, [selectedStartDate, selectedEndDate]);

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle
            style={{
              marginBottom: 16,
            }}
          >
            유입 검색어
          </TableTitle>
          <PretendardText
            style={{
              fontWeight: "500",
              fontSize: "13px",
              lineHeight: "18.75px",
              letterSpacing: "-0.3%",
              color: "#aaa",
              marginBottom: 30,
            }}
          >
            어떤 검색엔진에서 어떤 키워드로 내 사이트에 방문했는지 표시합니다.
          </PretendardText>

          <ContentContainer>
            <ContentHeader>
              <DatePicker
                popupIsOpen={popupIsOpen}
                onClick={() => {
                  setPopupIsOpen(!popupIsOpen);
                }}
                startDate={selectedStartDate}
                startDateHandler={(date) => {
                  setSelectedStartDate(date);
                }}
                endDate={selectedEndDate}
                endDateHandler={(date) => {
                  setSelectedEndDate(date);
                }}
                footerBtnHandler={() => {}}
              />
              {/* <ExcelBtn /> */}
            </ContentHeader>
            <table
              style={{
                width: "100%",
                borderSpacing: 0,
                borderCollapse: "collapse",
                marginTop: 20,
              }}
            >
              <colgroup>
                {/* 합계: 1044px */}
                {/* 검색어 */}
                <col width="225px" />
                {/* 검색엔진 */}
                <col width="207px" />
                {/* 클릭수 */}
                <col width="248px" />
                {/* 마지막 클릭 */}
                <col width="364px" />
              </colgroup>
              <thead>
                <tr
                  style={{
                    height: 41,
                    backgroundColor: "#313233",
                    borderTop: "0.5px solid rgba(255, 255, 255, 0.12)",
                  }}
                >
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                        paddingLeft: 30,
                      }}
                    >
                      검색어
                    </TableText>
                  </th>
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                        textAlign: "right",
                      }}
                    >
                      검색엔진
                    </TableText>
                  </th>
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                        textAlign: "right",
                      }}
                    >
                      클릭수
                    </TableText>
                  </th>
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                        textAlign: "right",
                        marginRight: 91,
                      }}
                    >
                      마지막 클릭
                    </TableText>
                  </th>
                </tr>
              </thead>
              <tbody>
                {[...Array(8)].map((_, index) => {
                  return (
                    <>
                      <tr
                        key={index}
                        style={{
                          height: 59,
                          borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                        }}
                      >
                        <td>
                          <TableText
                            style={{
                              maxWidth: 195,
                              paddingLeft: 30,
                            }}
                          >
                            제디피트
                          </TableText>
                        </td>
                        <td>
                          <TableText
                            style={{
                              maxWidth: 207,
                              textAlign: "right",
                            }}
                          >
                            naver.com
                          </TableText>
                        </td>
                        <td>
                          <TableText
                            style={{
                              maxWidth: 248,
                              textAlign: "right",
                            }}
                          >
                            {formatNumberWithCommas(2000)}
                          </TableText>
                        </td>
                        <td>
                          <TableText
                            style={{
                              textAlign: "right",
                              marginRight: 91,
                            }}
                          >
                            2024-07-07
                          </TableText>
                        </td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          </ContentContainer>
        </DetailPageLayout>
      </MainLayout>

      {modalIsOpen && (
        <Modal
          type="alert"
          title={modalTitle}
          text={modalText}
          setModalOpen={setModalIsOpen}
          onClick={() => {
            setModalIsOpen(false);
          }}
        />
      )}
    </>
  );
};

export default StatisticsInflowSearch;

const ContentContainer = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

const ContentHeader = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
